import { API_URL } from "../../utils/constants/api";
import axios from "axios";
import Qs from "qs";
import {
  localStorageAuthKey,
  unauthorized_status,
  forbidden_status,
  blocked_from_outside_israel_status,
} from "../../utils/constants/auth";
import history from "../../history";

export const addRequestObject = (store) => (next) => (action) => {
  const authReducer = JSON.parse(localStorage.getItem(localStorageAuthKey));
  if (authReducer === null) next(action);
  if (!action.request || !action.request.url) {
    return next(action);
  }
  action.request.url = API_URL + action.request.url;
  if (!action.request.hasOwnProperty("headers")) {
    action.request.headers = {};
  }
  if (authReducer && JSON.parse(authReducer.token))
    action.request.headers.Authorization = `Bearer ${authReducer.token.replace(
      /['"]+/g,
      ""
    )}`;
  next(action);
};

export const instance = axios.create({
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: "repeat" }),
  baseURL: API_URL,
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const {
      response: { status },
    } = error;
    const originalRequest = error.config;

    if (status === unauthorized_status && !originalRequest._retry) {
      originalRequest._retry = true;
      
      const authState = JSON.parse(localStorage.getItem(localStorageAuthKey) || '{}');
      const refreshToken = authState.refresh_token;
      
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_URL}/api/auth/token/refresh/`, {
            refresh: refreshToken.replace(/['"]+/g, "")
          });
          
          const { access, refresh } = response.data;
          authState.token = `"${access}"`;
          if (refresh) {
            authState.refresh_token = `"${refresh}"`;
          }
          localStorage.setItem(localStorageAuthKey, JSON.stringify(authState));
          setAxiosHeader(access);
          originalRequest.headers.Authorization = `Bearer ${access}`;
  
          return instance(originalRequest);
        } catch (refreshError) {
     
          localStorage.clear();
          history.push("/");
          return Promise.reject(refreshError);
        }
      } else {
        localStorage.clear();
        history.push("/");
      }
    }

    if (status === forbidden_status) {
      localStorage.clear();
      history.push("/");
    }

    if (
      status === blocked_from_outside_israel_status &&
      error.response.config.url.includes("api/host_salons_map")
    ) {
      return { data: [] };
    }

    return Promise.reject(error);
  }
);

export const setAxiosHeader = (token) => {
  if (token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    instance.defaults.headers.common.Authorization = null;
  }
};
